import { HttpClient } from '@angular/common/http';
// import { environment } from '../../../../environments/environment';
import { API } from 'aws-amplify';
import { Observable, of } from 'rxjs';
import { ConfigService } from '../../config';
import { VoucherDemoModeService } from '../../vouchers/demo/voucher-demo-mode.service';
import { buildDemoMachines } from '../../vouchers/demo/voucher-demo-dashboard';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../config/config.service";
import * as i3 from "../../vouchers/demo/voucher-demo-mode.service";
var UserSettingsHttpService = /** @class */ (function () {
    function UserSettingsHttpService(http, configService, demoMode) {
        this.http = http;
        this.configService = configService;
        this.demoMode = demoMode;
        this.apiName = this.configService.get('host');
    }
    UserSettingsHttpService.prototype.postSubscription = function (formObj) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/subscription';
            var params = {
                body: formObj
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    UserSettingsHttpService.prototype.updateSummaryReport = function (action) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/summary-report/' + action;
            var params = {
                body: {}
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    UserSettingsHttpService.prototype.getExistingSubsDet = function () {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get-existing-subs';
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    UserSettingsHttpService.prototype.getRegTerr = function (regionId, territoryId) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/' + regionId + '/' + territoryId;
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    UserSettingsHttpService.prototype.getTopics = function () {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get-topics';
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    UserSettingsHttpService.prototype.getDistis = function () {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get-distis';
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    UserSettingsHttpService.prototype.getUserAttr = function () {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get-user-attr';
            var myInit = {
                response: false
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    UserSettingsHttpService.prototype.getClients = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get-clients';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    UserSettingsHttpService.prototype.getCampus = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get-campus';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    UserSettingsHttpService.prototype.getMarkets = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get-markets';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    UserSettingsHttpService.prototype.getRecipes = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get-recipes';
            var myInit = {
                response: false
            };
            if (queryParams) {
                myInit.queryStringParameters = queryParams;
            }
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    UserSettingsHttpService.prototype.getProducts = function (queryParams) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/get-products';
            var myInit = {
                response: false
            };
            if (queryParams) {
                myInit.queryStringParameters = queryParams;
            }
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    UserSettingsHttpService.prototype.getMachines = function (queryParams) {
        var _this = this;
        if (this.demoMode.isEnabled()) {
            return of(buildDemoMachines());
        }
        return new Observable(function (observer) {
            var path = '/dashboard/get_all_macs';
            var myInit = {
                response: false,
                queryStringParameters: queryParams
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    UserSettingsHttpService.prototype.getNotifications = function (userId) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/analytics/get-notifications';
            var myInit = {
                response: false,
                queryStringParameters: {
                    user_id: userId
                }
            };
            API.get(_this.apiName, path, myInit).then(function (response) {
                observer.next(response.data);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    UserSettingsHttpService.prototype.updateNotifications = function (payload) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/analytics/update-notifications';
            var params = {
                body: payload
            };
            API.post(_this.apiName, path, params).then(function (result) {
                observer.next(result);
            }).catch(function (err) {
                console.log(err.response);
                observer.error(err);
            });
        });
    };
    UserSettingsHttpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function UserSettingsHttpService_Factory() { return new UserSettingsHttpService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService), i0.ɵɵinject(i3.VoucherDemoModeService)); }, token: UserSettingsHttpService, providedIn: "root" });
    return UserSettingsHttpService;
}());
export { UserSettingsHttpService };
